import React, { useState, useEffect } from "react";
import CampaignGroupListing from "./CampaignGroupListing";
import { columnTypes } from "src/components/UI/atoms/ATMTable/ATMTable";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "src/redux/store";
import {
  setItems,
  setPage,
  setRowsPerPage,
  setSearchValue,
  setIsTableLoading,
  setTotalItems,
} from "src/redux/slices/CampaignGroupSlice";
import { RxPencil1 } from "react-icons/rx";
import { MdDeleteOutline } from "react-icons/md";
import { showConfirmationDialog } from "src/utils/showConfirmationDialog";
import ATMMenu from "src/components/UI/atoms/ATMMenu/ATMMenu";
import AddCampaignGroupFormWrapper from "../Add/AddCampaignGroupFormWrapper";
import EditCampaignGroupFormWrapper from "../Edit/EditCampaignGroupFormWrapper";
import {
  useGetAllCampaignGroupWithPaginationQuery,
  useDeleteCampaignGroupMutation,
} from "src/services/CampaignGroup";
import { showToast } from "src/utils/showToaster";
import {
  UserModuleActionTypes,
  UserModuleNameTypes,
} from "src/models/userAccess/UserAccess.model";
import { isCheckColumnPermission } from "src/helpers/userAccessFun";
type Props = {};

const CampaignGroupListingWrapper = (props: Props) => {
  const [deleteCampaign] = useDeleteCampaignGroupMutation();
  const dispatch = useDispatch();
  const { items, totalItems, page, rowsPerPage, searchValue, isTableLoading } =
    useSelector((state: RootState) => state.campaignGroup);

  const [campaignGroupId, setCampaignGroupId] = useState("");

  const [isOpenAddFrom, setIsOpenAddForm] = useState(false);
  const [isOpenEditFrom, setIsOpenEditForm] = useState(false);

  const { isLoading, isFetching, data } =
    useGetAllCampaignGroupWithPaginationQuery({
      limit: rowsPerPage,
      searchValue: "",
      params: ["campaignGroupName", "channelLabel"],
      page: 0,
      filterBy: [],
      dateFilter: {},
      orderBy: "createdAt",
      orderByValue: -1,
      isPaginationRequired: true,
    });

  useEffect(() => {
    if (isLoading || isFetching) {
      dispatch(setIsTableLoading(true));
    } else {
      dispatch(setItems(data?.data || []));
      dispatch(setTotalItems(data?.totalItem || 0));
      dispatch(setIsTableLoading(false));
    }
  }, [isLoading, isFetching, data, dispatch]);

  const getActionOptions = (row: any) => {
    return [
      {
        label: (
          <div className="flex gap-2 items-center text-secondary-main">
            <RxPencil1 className="text-lg" /> Edit
          </div>
        ),
        onClick: () => {
          setIsOpenEditForm(true);
          setCampaignGroupId(row?._id);
        },
        actionName: UserModuleActionTypes.EDIT,
        moduleName: UserModuleNameTypes.CAMPAIGN_GROUP,
      },
      {
        label: (
          <div className="flex gap-2 items-center text-red-600 font-semibold">
            <MdDeleteOutline className="text-lg" /> Delete
          </div>
        ),
        onClick: () => {
          showConfirmationDialog({
            title: "Heads Up",
            text: "Are you sure want to Delete this Campaign Group ?",
            icon: "question",
            showCancelButton: true,
            next: (result) => {
              if (result.isConfirmed) {
                deleteCampaign(row?._id).then((res: any) => {
                  if (res?.error) {
                    showToast("error", res?.error?.data?.message);
                  } else {
                    if (res?.data?.status) {
                      showToast("success", res?.data?.message);
                    } else {
                      showToast("error", res?.data?.message);
                    }
                  }
                });
              }
            },
          });
        },
        actionName: UserModuleActionTypes.DELETE,
        moduleName: UserModuleNameTypes.CAMPAIGN_GROUP,
      },
    ];
  };
  const columns: columnTypes[] = [
    {
      field: "campaignGroupName",
      headerName: "Campaign Name",
      flex: "flex-[1_1_0%]",
      renderCell: (row: any) => <span> {row?.campaignGroupName} </span>,
    },
    {
      field: "channelLabel",
      headerName: "Channel",
      flex: "flex-[1_1_0%]",
      renderCell: (row: any) => <span>{row?.channelLabel}</span>,
    },
    {
      noAuthRequired: true,
      field: "action",
      headerName: "Action",
      flex: "flex-[1_1_0%]",
      renderCell: (row: any) => {
        const options = getActionOptions(row);
        return <ATMMenu options={options} orientation="vertical" />;
      },
    },
  ];

  return (
    <div>
      <CampaignGroupListing
        columns={isCheckColumnPermission({
          moduleName: UserModuleNameTypes.CAMPAIGN_GROUP,
          actionName: UserModuleActionTypes.LIST,
          columns: columns,
        })}
        rows={items}
        paginationProps={{
          isTableLoading,
          totalItems,
          page,
          rowsPerPage,
          searchValue,
          setPage: (newPage) => dispatch(setPage(newPage)),
          setRowsPerPage: (newRowsPerPage) =>
            dispatch(setRowsPerPage(newRowsPerPage)),
          setSearchValue: (newValue) => dispatch(setSearchValue(newValue)),
        }}
        onAddNew={() => setIsOpenAddForm(true)}
      />
      {isOpenAddFrom ? (
        <AddCampaignGroupFormWrapper onClose={() => setIsOpenAddForm(false)} />
      ) : null}
      {isOpenEditFrom ? (
        <EditCampaignGroupFormWrapper
          onClose={() => setIsOpenEditForm(false)}
          campaignGroupId={campaignGroupId}
        />
      ) : null}
    </div>
  );
};

export default CampaignGroupListingWrapper;
